import { sendCaptionTabNotification } from "./actions";

const DATA_MANAGEMENT_EVENT_TYPE_PREFIX = "data-management/";
export const DATA_MANAGEMENT_EVENT_TYPES = {
  CAPTION_TAB_NOTIFICATION: `${DATA_MANAGEMENT_EVENT_TYPE_PREFIX}caption-notification`,
};

export const handleIncomingMessage = (store: any) => (type: string, payload: any) => {
  if (!type.startsWith(DATA_MANAGEMENT_EVENT_TYPE_PREFIX)) {
    return;
  }

  const {
    task,
    title,
    url,
  }: {
    task: string | null;
    title: string | null;
    url: string | null;
  } = payload;

  switch (type) {
    case DATA_MANAGEMENT_EVENT_TYPES.CAPTION_TAB_NOTIFICATION:
      if (task && title && url) {
        store.dispatch(sendCaptionTabNotification(task, title, url));
      } else {
        console.warn("Missing required fields for CAPTION_TAB_NOTIFICATION");
      }
      break;
    default:
      break;
  }
};
